import { api, LightningElement } from "lwc";

import { assignedSlotNames } from "common/slot";
import { createTrack } from "common/track";

import { FooterLink, FooterColumn } from "./types";
export default class extends LightningElement {
  @api columns: FooterColumn[] = null!;

  private slots: string = "";
  private track = createTrack<"tds-footer-links">(this);

  private get _columns() {
    return this.columns.map((col) => {
      return Object.assign({}, col, {
        links: col.links.map((link) => {
          return Object.assign({}, link, {
            handleClick: this.handleLinkClick.bind(this, link),
          });
        }),
      });
    });
  }

  private handleLinkClick(link: FooterLink) {
    // Keep for backwards compatbility
    this.dispatchEvent(new CustomEvent("link_click", { detail: link }));
    this.track("link_clicked", { label: link.label });
  }

  private handleSlotChange() {
    this.slots = assignedSlotNames(this.template).join(" ");
  }
}
